import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=dda0805c&scoped=true&"
import script from "./newGroup.ts?vue&type=script&lang=ts&"
export * from "./newGroup.ts?vue&type=script&lang=ts&"
import style0 from "./NewGroup.vue?vue&type=style&index=0&id=dda0805c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda0805c",
  null
  
)

export default component.exports